import React from 'react';
import RocketsList from '../components/rocketsComponents/RocketsList';

const Rockets = () => (
  <div className="rockets-page-container">
    <RocketsList />
  </div>
);

export default Rockets;
